import useStore from "@/store/zustandStore";
import { useShallow } from "zustand/react/shallow";

export const useCommentForm = () =>
  useStore(
    useShallow((state) => ({
      viewId: state.viewId,
      toggleId: state.toggleId,
      deleteId: state.deleteId,
    }))
  );
